import { Component, Input, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { ApiService } from '../../shared/services/api/api.service';
import { TranslateModule } from '@ngx-translate/core';
import { User } from '../../models/user';

@Component({
  selector: 'app-modal-crm-integration',
  standalone: true,
  imports: [CommonModule, MatIcon, TranslateModule],
  templateUrl: './modal-crm-integration.component.html',
  styleUrls: ['./modal-crm-integration.component.scss'],
})
export class ModalCrmIntegrationComponent implements OnInit {
  @Input({ required: true }) authorizationUrl!: string;
  mailtoHref: string = 'mailto:equipecsm@explain.fr';
  private currentUser: User | null = null;

  constructor(
    private activeModal: NgbActiveModal,
    private apiService: ApiService
  ) {}

  async ngOnInit() {
    this.updateMailtoHref();
    try {
      this.currentUser = await firstValueFrom(this.apiService.user.getUser());
    } catch (error) {
      console.error('Error getting own user', error);
      this.currentUser = null;
    } finally {
      this.updateMailtoHref();
    }
  }

  private updateMailtoHref() {
    const email = 'equipecsm@explain.fr';
    const userDisplayName = this.currentUser?.fullName || this.currentUser?.email || '';
    const company = this.currentUser?.company || '';
    const identity = userDisplayName && company ? `${userDisplayName}/${company}` : userDisplayName || company;
    const subject = identity ? `Explain - ${identity} - Connexion au CRM` : `Explain - Connexion au CRM`;
    const body = [
      'Bonjour,',
      '',
      "Je voudrais connecter Explain à mon CRM mais j'obtiens une erreur, pouvez vous me recontacter s'il vous plait ?",
    ].join('\n');
    this.mailtoHref = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  dismissModal() {
    this.activeModal.dismiss();
  }

  openAuthorization(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // Close the modal and pass the child window reference back to the caller
    const child = window.open(this.authorizationUrl, '_blank');
    this.activeModal.close(child || null);
  }
}
